<!-- BOM物料 -->
<template>
  <BaseFormItem
    class="buy_bom"
    :label="fields.label"
    :labelTips="fields.labelTips"
    :isError="isError"
    :isErrorBlink="isErrorBlink"
  >
    <BaseRadioGroup v-model="val" @change="handleEmit">
      <el-radio
        border
        v-for="item in fields.options"
        :key="item.value"
        :label="item.value"
      >
        {{ item.label }}
        <span v-if="item.desc" class="buy_bom__desc">
          {{ item.desc }}
        </span>
      </el-radio>
    </BaseRadioGroup>
    <div v-if="val === 1" class="buy_bom__tips">
      <i class="buy_bom__tips__linker"></i>
      <p>专职团队，最快8小时完成配单和报价 (工作时间)</p>
      <p>如需<span>自供部分物料</span>，请在文件内备注</p>
    </div>
    <!-- BOM订单列表 -->
    <div v-if="val === 3" class="buy_bom__list">
      <i class="buy_bom__list__linker"></i>
      <BomList :item="currentItem" @change="handleItemChange" />
    </div>
  </BaseFormItem>
</template>

<script>
import BomList from '@@/components/bomList/index'

import { getSMTFields } from '@@/utils/getFields'

export default {
  props: {
    value: {
      type: [Number, String],
      default: ''
    },
    item: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    BomList
  },
  data() {
    return {
      val: this.value,
      currentItem: {},
      isError: false, // 是否显示错误提示样式
      isErrorBlink: false, // 是否显示错误提示样式且闪两下
    }
  },
  computed: {
    fields() {
      return getSMTFields('buy_bom')
    }
  },
  watch: {
    value(newVal) {
      this.val = newVal
    },
    item(item) {
      this.currentItem = item
    }
  },
  methods: {
    handleEmit() {
      const val = this.val
      this.$emit('input', val)
      this.handleEmitChange()
    },
    handleEmitChange() {
      const { val, currentItem } = this
      this.$emit('change', val, currentItem)
      this.isShowError(false)
    },
    handleItemChange(item) {
      this.currentItem = item
      this.handleEmitChange()
    },
    // 是否显示错误提示样式
    isShowError(isShow, isBlink = false) {
      this.isError = isShow
      this.isErrorBlink = isBlink
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@@/styles/mixin.scss';

.buy_bom {
  .buy_bom__desc {
    color: $--color-text-placeholder;
  }
  .buy_bom__tips {
    position: relative;
    margin-top: 5px;
    padding: 10px;
    width: 310px;
    font-size: 12px;
    line-height: 1.5;
    border-radius: $--border-radius-base;
    background-color: $--background-base;
    .buy_bom__tips__linker {
      @include moduleLinkerMixin(15px, vertical, dark);
      position: absolute;
      top: -10px;
      left: 6px;
    }
    >p {
      color: $--color-text-secondary;
      &:last-child {
        color: $--color-text-placeholder;
        >span {
          color: $--color-warning;
        }
      }
    }
  }

  .buy_bom__list {
    position: relative;
    margin-top: 5px;
    .buy_bom__list__linker {
      @include moduleLinkerMixin(15px, vertical, dark);
      position: absolute;
      top: -10px;
      left: 130px;
    }
  }
}
</style>